import { useState } from "react";
import { Button, Modal } from "antd";
import { MailOutlined } from "@ant-design/icons";
import Axios from "../../config/config";
import { Link, useNavigate } from "react-router-dom";

// field error string ya array dono ho sakta hai
const fieldError = (value) =>
  Array.isArray(value) ? value.join(", ") : value;

const emptySignup = {
  first_name: "",
  email: "",
  phone: "",
  password: "",
  confirm_password: "",
};

const Registration = () => {
  const navigate = useNavigate();
  const [signupLoader, setSignupLoader] = useState(false);
  const [signup, setSignup] = useState(emptySignup);
  const [showVerifyModal, setShowVerifyModal] = useState(false);
  const [registeredEmail, setRegisteredEmail] = useState("");
  const [errors, set_errors] = useState({});

  const handleSignupChange = (field, value) => {
    setSignup((prev) => ({ ...prev, [field]: value }));
    // is field ka error hata do
    if (errors[field]) {
      set_errors((prev) => ({ ...prev, [field]: undefined }));
    }
    // phone ka backend key contact_no hai
    if (field === "phone" && errors.contact_no) {
      set_errors((prev) => ({ ...prev, contact_no: undefined }));
    }
  };

  // koi frontend validation nahi: sab validation/error backend se aata hai
  const handleSignup = async () => {
    set_errors({});
    setSignupLoader(true);
    try {
      const formData = new FormData();
      formData.append("first_name", signup.first_name);
      formData.append("email", signup.email);
      formData.append("contact_no", signup.phone);
      formData.append("password", signup.password);
      formData.append("confirm_password", signup.confirm_password);

      const res = await Axios.post("register/", formData);

      if (res?.data?.status) {
        // success: "mail check karo" wala modal kholo
        setRegisteredEmail(signup.email);
        setSignup(emptySignup);
        navigate("/");
        // setShowVerifyModal(true);
      } else {
        set_errors(res?.data?.errors || {});
      }
    } catch (err) {
      set_errors(err?.response?.data?.errors || {});
    }
    setSignupLoader(false);
  };

  return (
    <>
      <h2>Sign Up</h2>
      <p className="subtitle">Create your account to get started</p>

      {/* First Name */}
      <input
        className="input"
        placeholder="Name"
        value={signup.first_name}
        onChange={(e) => handleSignupChange("first_name", e.target.value)}
      />
      {errors.first_name && (
        <p className="error">{fieldError(errors.first_name)}</p>
      )}

      {/* Email */}
      <input
        className="input"
        placeholder="Email address"
        value={signup.email}
        onChange={(e) => handleSignupChange("email", e.target.value)}
      />
      {errors.email && (
        <p className="error">{fieldError(errors.email)}</p>
      )}

      {/* Contact Number */}
      <input
        className="input"
        maxLength={10}
        placeholder="Contact No"
        value={signup.phone}
        onChange={(e) => handleSignupChange("phone", e.target.value)}
      />
      {(errors.contact_no || errors.phone) && (
        <p className="error">
          {fieldError(errors.contact_no || errors.phone)}
        </p>
      )}

      {/* Password */}
      <input
        type="password"
        className="input"
        placeholder="Password"
        value={signup.password}
        onChange={(e) => handleSignupChange("password", e.target.value)}
      />
      {errors.password && (
        <p className="error">{fieldError(errors.password)}</p>
      )}

      {/* Confirm Password */}
      <input
        type="password"
        className="input"
        placeholder="Confirm Password"
        value={signup.confirm_password}
        onChange={(e) =>
          handleSignupChange("confirm_password", e.target.value)
        }
      />
      {errors.confirm_password && (
        <p className="error">
          {fieldError(errors.confirm_password)}
        </p>
      )}

      <div className="auth-btn-row">
        <Button
          className="btn-primary"
          onClick={handleSignup}
          loading={signupLoader}
        >
          Sign Up
        </Button>
      </div>

      <div className="auth-switch">
        Already have an account? <Link to="/">Sign In</Link>
      </div>

      {/* SIGN UP SUCCESS: CHECK YOUR MAIL MODAL */}
      <Modal
        open={showVerifyModal}
        footer={null}
        centered
        maskClosable={false}
        keyboard={false}
        closable={false}
        width={400}
      >
        <div className="verify-modal">
          <div className="verify-icon">
            <MailOutlined />
          </div>

          <h3>Check your mail</h3>
          <p>
            Please check your mail <b>{registeredEmail}</b> to verify your
            account.
          </p>

          <div className="auth-switch">
            <Link to="/" onClick={() => setShowVerifyModal(false)}>
              Sign In
            </Link>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Registration;